import { defineStore } from "pinia";
import { computed, ref } from "vue";
import createDebug from 'debug';

const debug = createDebug('store:logger');

export const useLoaderStore = defineStore(
  'loader',
  () => {
    const stack = ref(0);
    const active = computed(() => stack.value > 0);

    return {
      active,
      show() {
        stack.value++;
        debug(`Showing loader. Current stack = ${stack.value}`);
      },
      hide() {
        if (stack.value > 0) {
          stack.value--;
          debug(`Hiding loader. Current stack = ${stack.value}`);
        }
      },
      forceHide() {
        stack.value = 0;

        debug('Forced loader hide.');
      },
      wrap(fn: () => Promise<any>) {
        this.show();

        return fn().finally(() => this.hide());
      },
    }
  }
);
